module.exports = __webpack_public_path__ + "img/s2.b231bc1d.png";